export const contact = {
  company: "บริษัท โทนส์ มิวสิค จำกัด",
  address: "59/179 ม.4 ต.คลองสอง อ.คลองหลวง",
  province: "จ.ปทุมธานี 12120",
  email: "tonesmusiccompany@gmail.com",
  phone_number: "083-288-8212",
};
